import { Anchor, atAnchor, type Offset, type Rect } from './geometry'
import { LinearTransform } from './transform'

const percentages = { x: 0, y: 0, width: 100, height: 100 }

/** CSS applies a matrix about an element-relative origin, unlike apply(). */
export function transformCSS(transform: LinearTransform, origin: Anchor = Anchor.topLeft) {
  const point = atAnchor(percentages, origin)
  return {
    transform: LinearTransform.toCSS(transform),
    transformOrigin: `${point.x}% ${point.y}%`
  }
}

/**
 * DOM counterpart of anchored(): CSS resolves the follower's unknown size.
 * An omitted target means the positioned parent. Offsets are in parent units.
 * Transform about the attachment point first, then offset and attach it; this
 * keeps inverse-scaled controls attached while the document zoom changes.
 */
export function anchoredCSS({
  target,
  targetAnchor,
  followerAnchor,
  followerOffset,
  followerTransform
}: {
  target?: Rect
  targetAnchor: Anchor
  followerAnchor: Anchor
  followerOffset: Offset
  followerTransform: LinearTransform
}) {
  const targetPoint = atAnchor(target ?? percentages, targetAnchor)
  const followerPoint = atAnchor(percentages, followerAnchor)
  const style = transformCSS(followerTransform, followerAnchor)
  let left: number | string = `${targetPoint.x}%`
  let top: number | string = `${targetPoint.y}%`
  if (target) {
    left = targetPoint.x
    top = targetPoint.y
  }
  return {
    left,
    top,
    ...style,
    transform: `translate(${-followerPoint.x}%, ${-followerPoint.y}%) translate(${
      followerOffset.dx
    }px, ${followerOffset.dy}px) ${style.transform}`
  }
}
